// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import iView from 'iview'
import App from './App'
import router from './router'
import axios from 'axios'
import Lockr from 'lockr'
import Util from './libs/util'
import 'iview/dist/styles/iview.css'
import 'font-awesome/css/font-awesome.min.css'
import $ from 'jquery'
import { VueJsonp } from 'vue-jsonp'
import VueAMap from 'vue-amap/'

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '9c8dad04159dca247e6709ec403bd40a',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.Geocoder', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});


Vue.use(iView)
Vue.use(VueJsonp)

Vue.config.productionTip = false

axios.defaults.baseURL = process.env.API_URL
axios.defaults.withCredentials = true
axios.defaults.timeout = 1000 * 15

window.Lockr = Lockr
window.axios = axios
window.Bus = new Vue()

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  Util.title(to.meta.title)
  let level = Util.level(to.name, Lockr.get('menus'))
  if(!level && ['Login', 'Home'].indexOf(to.name) == -1 ) {
    iView.Message.error('没有权限，请联系管理员')
    iView.LoadingBar.error()
    return true
  }
  next()
})

router.afterEach((to, from, next) => {
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

axios.interceptors.response.use(response => {
  if(!response.data.state) {
    iView.Message.error(response.data.error.join('，'))
    iView.LoadingBar.error()
  }
  return response
}, error => {
  switch (error.response.status) {
    case 500:
      iView.Message.error('服务器内部错误')
      break;
    case 401:
      if (!window.hideLogout) {
        iView.Message.warning('登录失效，请重新登录')
        window.hideLogout = true
      }
      router.push({ name: 'Login' })
      break;
    case 403:
      iView.Message.warning('禁止访问')
      break;
  }
  return Promise.reject(error);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  created () {
    window.axios.defaults.headers.common = {
      'X-Requested-With': 'XMLHttpRequest'
    };
    if (Lockr.get('token')) {
      window.axios.defaults.headers.common['Authorization'] = `Bearer ${Lockr.get('token')}`;
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js